export default __webpack_public_path__ + "static/media/sadEmoji.99f3a1c2.svg";